// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3agW8","placeholdersHeader":"styles_placeholdersHeader__2Eh0B","editorStyle":"styles_editorStyle__1KDnt","placeholdersBox":"styles_placeholdersBox__2hhI0"};